import React from "react";
import { Home } from "../tabs/home/home.tab";
import { Contact } from "../tabs/contact/contact.tab";
import { Specialties } from "../tabs/subjects/specialties.tab";
import { ethIcon } from "../utils/svg";

export enum TabKeys {
  Home = 1,
  Specialties = 2,
  Contact = 3,
}

export interface Tab {
  index: number;
  key: TabKeys;
  title: string;
  icon: string | undefined;
  component: React.ReactElement;
}

export const tabs: Tab[] = [
  {
    index: 1,
    key: TabKeys.Home,
    title: "Home",
    icon: ethIcon,
    component: <Home />,
  },
  {
    index: 2,
    key: TabKeys.Specialties,
    title: "Journey",
    icon: ethIcon,
    component: <Specialties />,
  },
  {
    index: 3,
    key: TabKeys.Contact,
    title: "Contact",
    icon: ethIcon,
    component: <Contact />,
  },
];
